import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { authServiceReactQueryContext, authServiceTrpc } from '../utilities/react-auth-service-trpc';
import { httpBatchLink } from '@trpc/client';
import { APP_CONFIG } from '../config/app-config';
import { getAuth } from 'firebase/auth';
import rootStore from 'stores/rematch/root-store';

export function AuthServiceTrpcProvider({ children }: { children: React.ReactNode }) {
  const [queryClient] = React.useState(() => new QueryClient());
  const [trpcClient] = React.useState(() =>
    authServiceTrpc.createClient({
      links: [
        httpBatchLink({
          url: `${APP_CONFIG.AUTH_SERVICE_ORIGIN}/trpc`,
          async headers() {
            const currentUser = getAuth().currentUser;
            const idToken = await currentUser?.getIdToken();
            const authStore = rootStore.getState().authStore;
            const serviceProviderId =
              authStore.serviceProviderId ??
              authStore.portalUser?.serviceProviderId ??
              window.sessionStorage.getItem('serviceProviderId') ??
              undefined;

            return {
              authorization: idToken ? `Bearer ${idToken}` : undefined,
              serviceproviderid: serviceProviderId,
            };
          },
        }),
      ],
    }),
  );

  return (
    <authServiceTrpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient} context={authServiceReactQueryContext}>
        {children}
      </QueryClientProvider>
    </authServiceTrpc.Provider>
  );
}
